const ALLOWED_PROTOCOLS = ['http:', 'https:', 'mailto:']

/**
 * Returns `value` trimmed if it's an absolute http(s):// or mailto: URL, or null otherwise
 * (javascript:, data:, relative paths, garbage...). Links in blocks end up in the public
 * page's href, so anything read from saved/pasted HTML or typed by the user goes through here.
 */
export function safeLinkUrl(value) {
  const url = typeof value === 'string' ? value.trim() : ''
  if (!url) return null

  try {
    return ALLOWED_PROTOCOLS.includes(new URL(url).protocol) ? url : null
  } catch (error) {
    return null
  }
}
